import React from "react";
import { Box, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

export default function OfficialRulesDisclosure({
  text = "",
  title = "Official Rules",
  helperText = "View raffle fine print",
}) {
  const theme = useTheme();
  const rulesText = String(text || "").trim();
  if (!rulesText) return null;

  return (
    <Box
      component="details"
      sx={{
        borderRadius: 1,
        border:
          theme.palette.mode === "dark"
            ? `1px solid ${alpha(theme.palette.common.white, 0.14)}`
            : `1px solid ${alpha(theme.palette.text.primary, 0.09)}`,
        bgcolor: alpha(theme.palette.background.paper, theme.palette.mode === "dark" ? 0.4 : 0.76),
        overflow: "hidden",
      }}
    >
      <Box
        component="summary"
        sx={{
          px: 1.75,
          py: 1.35,
          cursor: "pointer",
          listStyle: "none",
          "&::-webkit-details-marker": { display: "none" },
        }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 850 }}>
          {title}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {helperText}
        </Typography>
      </Box>
      <Box sx={{ px: 1.75, pb: 1.5 }}>
        <Typography
          variant="body2"
          component="pre"
          color="text.secondary"
          sx={{ m: 0, whiteSpace: "pre-wrap", fontFamily: "inherit" }}
        >
          {rulesText}
        </Typography>
      </Box>
    </Box>
  );
}
